<script setup lang="ts">
import useCompanyName from '@Use/useCompanyName';
import { ErrorScreenLayout, SupportEmailLink } from '@Shared';
import BrowserWaiting from '@Assets/images/browser_waiting.svg';
import AuthErrorShell from '@Components/AuthErrorShell.vue';

const { companyName } = useCompanyName();
</script>

<template>
    <auth-error-shell class="pause-view">
        <div class="pause-view__content">
            <error-screen-layout
                :image="BrowserWaiting"
                image-alt="Paused"
                title="We're reviewing your request"
                image-width="12rem"
                image-height="10rem">
                <p>
                    CertifID is reviewing the details of this request as part of our standard security process.
                </p>
                <p>
                    To keep your information safe, we've temporarily paused your progress.
                    The review could take up to 2 hours.
                </p>
                <p>
                    {{ companyName }} has been notified. If you have any questions, contact <support-email-link />.
                </p>
            </error-screen-layout>
        </div>
    </auth-error-shell>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.pause-view {
    @include desktop {
        padding-top: 10.25rem;
    }

    &__content {
        border-radius: 0.25rem;
        background-color: $white;
        max-width: 24.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        line-height: 150%;
        margin-bottom: 30px;
        color: $black-high;
    }
}
</style>
